import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';
import successAnimation from '../../assets/json/successful.json';
import failAnimation from '../../assets/json/failure.json';
import warningAnimation from '../../assets/json/warning.json';
import style from './successModal.module.css';
import {ReactComponent as SendBackIcon} from '../../assets/images/sendBack.svg';

const SuccessModal = ({
  open,
  onClose,
  message,
  subMessage,
  reject,
  onHold,
  sendBack,
}) => {
  const getContent = () => {
    if (reject) {
      return (
        <Lottie
          animationData={failAnimation}
          loop={false}
          className={style.lottie}
        />
      );
    } else if (onHold) {
      return (
        <Lottie
          animationData={warningAnimation}
          loop={false}
          className={style.lottie}
        />
      );
    } else if (sendBack) {
      return <SendBackIcon />;
    }

    return (
      <Lottie
        animationData={successAnimation}
        loop={false}
        className={style.lottie}
      />
    );
  };

  return (
    <Dialog
      onClick={event => event.stopPropagation()}
      open={open}
      onClose={!reject ? onClose : () => {}}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}>
      <Box className={style.box_container}>
        {' '}
        <Box className={style.box_inner}>{getContent()}</Box>
        <Box className={style.box_content}>
          <Box className={`text-medium-18px ${style.box_title}`}>{message}</Box>
          <Box className={`text-400-14px ${style.box_color}`}>{subMessage}</Box>
        </Box>
      </Box>
    </Dialog>
  );
};

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.any,
  message: PropTypes.string.isRequired,
  subMessage: PropTypes.string.isRequired,
  reject: PropTypes.bool,
  sendBack: PropTypes.any,
  onHold: PropTypes.any,
};

export default SuccessModal;
